import * as Constants from '../constants';

import { useState } from 'react';

import Modal from "./UI/Modal";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Form, Button } from 'react-bootstrap';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import MessageDialog from "../components/UI/dialog/MessageDialog"

import classes from "./AssetForm.module.css"


const AssetForm = (props) => {
    const [rowId,] = useState((props.active ? props.active.id : -1));
    const [tickerId, setTickerId] = useState(() =>
        props.active && props.active.ticker && props.active.ticker !== 0
            ? props.active.ticker
            : props.assets[0].title || ""
    );
    const [quotas, setQuotas] = useState((props.active ? props.active.quotas : 1));
    const [averagePrice, setAveragePrice] = useState((props.active ? props.active.price : 1));

    const [pendingAssetData, setPendingAssetData] = useState(null);
    const [messageIsShown, setMessageIsShown] = useState(false);
    const [messageDialog, setMessageDialog] = useState({
        variant: 'info',
        header: '',
        message: ''
    });


    const addURL = `${Constants.ADD_ASSET}`;
    const editURL = `${Constants.UPDATE_ASSET}`;

    const changeTickerHandler = (value) => {
        setTickerId(value);
    };

    const changeQuotasHandler = (value) => {
        setQuotas(value);
    };

    const changeAveragePriceHandler = (value) => {
        setAveragePrice(value);
    };


    const submitAssetHandler = async (event) => {
        event.preventDefault();

        const assetData = {
            id: rowId,
            ticker: tickerId,
            quotas,
            averagePrice
        };

        try {
            const url = props.edit ? editURL : addURL;
            const token = localStorage.getItem("token");

            const response = await fetch(url, {
                method: props.method,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(assetData)
            });

            const result = await response.json().catch(() => ({}));

            if (!response.ok) {
                setMessageDialog({
                    variant: 'danger',
                    header: 'Falha na operação!',
                    message: result.message || result.error || 'Não foi possível salvar o ativo. Tente novamente.'
                });

                setMessageIsShown(true);
                return;
            }

            setMessageDialog({
                variant: 'success',
                header: 'Operação realizada!',
                message: result.message || 'Ativo salvo com sucesso!'
            });

            setMessageIsShown(true);

            // Finaliza somente após o fechamento da mensagem
            setPendingAssetData(assetData);

        } catch (error) {
            setMessageDialog({
                variant: 'danger',
                header: 'Erro de comunicação!',
                message: 'Não foi possível estabelecer comunicação com o servidor.'
            });

            setMessageIsShown(true);
        }
    };

    return (
        <>
            <Modal modalClass={classes.modal} onClose={props.onClose}>
                <Form onSubmit={submitAssetHandler}>
                    <Container>
                        <Row>
                            <Col xs={2}>
                                <Form.Group className="mb-3" controlId="formBasicName">
                                    <Form.Label className="fw-bold pt-1">Ativo:</Form.Label>
                                    <Form.Control as="select" value={tickerId} onChange={(e) => { changeTickerHandler(e.target.value) }}>
                                        {
                                            props.assets.map((asset) =>
                                                <option key={asset.id} value={asset.title}>{asset.title}</option>
                                            )
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </Col>

                            <Col xs={4}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label className="fw-bold pt-1">Cotas:</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step={props.step || 1}
                                        value={quotas}
                                        onChange={(e) => changeQuotasHandler(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={4}>
                                <Form.Group className="mb-3" controlId="formBasicMessage">
                                    <Form.Label className="fw-bold pt-1">Preço Médio:</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="0.01"
                                        value={averagePrice}
                                        onChange={(e) => changeAveragePriceHandler(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            {props.edit &&
                                <Col xs={2}>
                                    <Form.Label className="fw-bold pt-1">&nbsp;</Form.Label><br />
                                    <Button variant="primary" type="submit" className={classes.assetFormButton}>
                                        <FontAwesomeIcon icon={faFloppyDisk} />&nbsp;Editar
                                    </Button>
                                </Col>
                            }
                            {!props.edit &&
                                <Col xs={2}>
                                    <Form.Label className="fw-bold pt-1">&nbsp;</Form.Label><br />
                                    <Button variant="primary" type="submit" className={classes.assetFormButton}>
                                        <FontAwesomeIcon icon={faFloppyDisk} />&nbsp;Adicionar
                                    </Button>
                                </Col>
                            }
                        </Row>
                    </Container>
                </Form>
            </Modal>
            {messageIsShown && (
                <MessageDialog
                    variant={messageDialog.variant}
                    header={messageDialog.header}
                    message={messageDialog.message}
                    onClose={() => {
                        setMessageIsShown(false);

                        if (pendingAssetData) {
                            props.onFinishSubmit(pendingAssetData);
                            setPendingAssetData(null);
                        }
                    }}
                />
            )}
        </>
    );
};

export default AssetForm;